import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const DashboardWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, dashboardReport:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, dashboardReport:false}))
    }

    useEffect(() => {
        start("dashboard", "dashboard-report", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Select target branch",
                placement: "right",
                target: "#walkthrough-dashboard-step-1",
                disableBeacon: true
            },
            {
                content: "Select the date from ",
                placement: "right",
                target: "#walkthrough-dashboard-step-2",
                disableBeacon: true
            },
            {
                content: "Select the date to",
                placement: "right",
                target: "#walkthrough-dashboard-step-3",
                disableBeacon: true
            },
            {
                content: "Click Generate to generate the report",
                placement: "right",
                target: "#walkthrough-dashboard-step-4",
                disableBeacon: true
            },
        ]

    return (
        <JoyrideWrapper 
            run={walkthrough.data.dashboardReport && window.location.pathname === pathname && !walkthrough.data.onboarding} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="dashboard-report" 
            featureName="dashboard"
        />
    );
}


